import { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const GameContext = createContext();

const TIME_STORAGE_KEY = "GAME_TIME_REMAIN";
const PLAYER_NAME_KEY = "PLAYER_NAME";
const PLAYER_KEY_CODE = "PLAYER_KEY_CODE"; // 🔑 ADD

export function GameProvider({ children }) {
  const location = useLocation();

  /* =========================
     이름 (유지)
  ========================= */
  const [playerName, setPlayerName] = useState(() => {
    return localStorage.getItem(PLAYER_NAME_KEY) || "";
  });

  useEffect(() => {
    if (playerName) {
      localStorage.setItem(PLAYER_NAME_KEY, playerName);
    }
  }, [playerName]);

  /* =========================
     🔑 keyCode (ADD)
  ========================= */
  const [playerKeyCode, setPlayerKeyCode] = useState(() => {
    return localStorage.getItem(PLAYER_KEY_CODE) || "";
  });

  useEffect(() => {
    if (playerKeyCode) {
      localStorage.setItem(PLAYER_KEY_CODE, playerKeyCode);
    }
  }, [playerKeyCode]);

  /* =========================
     시간
  ========================= */
  const [time, setTime] = useState(() => {
    const saved = localStorage.getItem(TIME_STORAGE_KEY);
    return saved !== null ? Number(saved) : 1800;
  });

  const [isRunning, setIsRunning] = useState(false);

  useEffect(() => {
    if (!isRunning) return;

    const id = setInterval(() => {
      setTime((prev) => {
        if (prev <= 1) {
          clearInterval(id);
          localStorage.removeItem(TIME_STORAGE_KEY);
          alert("시간이 초과되었습니다.");
          window.location.href = "/";
          return 0;
        }
        const next = prev - 1;
        localStorage.setItem(TIME_STORAGE_KEY, next);
        return next;
      });
    }, 1000);

    return () => clearInterval(id);
  }, [isRunning]);

  /* =========================
     루트(/) 진입 시 전체 초기화
  ========================= */
  useEffect(() => {
    if (location.pathname === "/") {
      setIsRunning(false);
      setTime(1800);
      localStorage.removeItem(TIME_STORAGE_KEY);

      setPlayerName("");
      setPlayerKeyCode("");
      localStorage.removeItem(PLAYER_NAME_KEY);
      localStorage.removeItem(PLAYER_KEY_CODE);

      setHintView("NONE");
      setHintIndex(null);
      setBackgroundNone(false);
      setClearedStages(new Set());
    }
  }, [location.pathname]);

  /* =========================
     스테이지 / 미션 (기존 유지)
  ========================= */
  const missionTotal = 16;
  const [clearedStages, setClearedStages] = useState(new Set());

  const clearStageOnce = (stageKey) => {
    if (!stageKey) return;
    setClearedStages((prev) => {
      if (prev.has(stageKey)) return prev;
      const next = new Set(prev);
      next.add(stageKey);
      return next;
    });
  };

  const increaseMissionOnce = (missionKey) => {
    clearStageOnce(missionKey);
  };

  /* =========================
     힌트 (기존 유지)
  ========================= */
  const [hintView, setHintView] = useState("NONE");
  const [hintIndex, setHintIndex] = useState(null);
  const [backgroundNone, setBackgroundNone] = useState(false);

  const openHint = () => {
    setHintIndex(null);
    setHintView("LIST");
    setBackgroundNone(true);
  };

  const openHintDetail = (idx) => {
    setHintIndex(idx);
    setHintView("DETAIL");
    setBackgroundNone(true);
  };

  const backFromHint = () => {
    if (hintView === "DETAIL") {
      setHintIndex(null);
      setHintView("LIST");
    } else {
      setHintIndex(null);
      setHintView("NONE");
      setBackgroundNone(false);
    }
  };

  const closeHint = () => {
    setHintIndex(null);
    setHintView("NONE");
    setBackgroundNone(false);
  };

  return (
    <GameContext.Provider
      value={{
        playerName,
        setPlayerName,

        // 🔑 ADD
        playerKeyCode,
        setPlayerKeyCode,

        time,
        startTimer: () => setIsRunning(true),
        pauseTimer: () => setIsRunning(false),

        missionTotal,
        clearedStages,
        increaseMissionOnce,

        hintView,
        hintIndex,
        openHint,
        openHintDetail,
        backFromHint,
        closeHint,

        backgroundNone,
      }}
    >
      {children}
    </GameContext.Provider>
  );
}

export const useGame = () => useContext(GameContext);
